var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"childpool-wrap"},[_c('CRow',[_c('CCol',{attrs:{"md":"6"}},[_c('Form',{attrs:{"handler":(_vm.partnerId)?_vm.update:_vm.create,"partnerId":_vm.partnerId,"partner":_vm.partner}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }